const Privacy = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
      <p className="text-lg mb-4">
        Our commitment to protecting your privacy and personal information.
      </p>
    </div>
  );
};

export default Privacy; 